<template>
  <div class="Main-Inner">
    <div class="Main-Sidebar-Wrapper">
      <div class="Main-Sidebar">
        <ul class="nav" id="dashboard-nav">
          <template v-if="theUser.webPushEnabled && theUser.hasNotificationAccess">
            <li class="section">{{$t('Notifications')}}</li>
            <router-link to="/messaging/notifications/dashboard/" tag="li" active-class="active"><a class="nav-link">{{$t('Dashboard')}}</a></router-link>
            <!-- <li class="section"></li> -->
            <router-link to="/messaging/notifications/list/type/manual/" tag="li" active-class="active"><a class="nav-link">{{$t('Manual')}}</a></router-link>
            <router-link to="/messaging/notifications/list/type/template/" tag="li" active-class="active"><a class="nav-link">{{$t('Template')}}</a></router-link>
            <!-- <li class="section"></li> -->
            <router-link to="/messaging/notifications/settings/" tag="li" active-class="active"><a class="nav-link">{{$t('Settings')}}</a></router-link>
          </template>
          <template v-if="theUser.smsEnabled && theUser.hasSmsAccess">
            <li class="section">{{$t('SMS Messaging')}}</li>
            <router-link to="/messaging/sms/dashboard/" tag="li" active-class="active"><a class="nav-link">{{$t('Dashboard')}}</a></router-link>
            <!-- <li class="section"></li> -->
            <router-link to="/messaging/sms/list/type/manual/" tag="li" active-class="active"><a class="nav-link">{{$t('Manual')}}</a></router-link>
            <router-link to="/messaging/sms/list/type/template/" tag="li" active-class="active"><a class="nav-link">{{$t('Template')}}</a></router-link>
            <!-- <li class="section"></li> -->
            <router-link to="/messaging/sms/settings/" tag="li" active-class="active"><a class="nav-link">{{$t('Settings')}}</a></router-link>
          </template>
        </ul>
      </div>
    </div>
    <div class="Main-Content">
      <LoadingLayout v-if="loading" :page="true" />
      <router-view v-if="!loading"></router-view>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: true,
      store: {
        languages: null,
        domains: null,
        countries: null,
        accountTimezone: null,
        sessionKey: null
      }
    }
  },
  mounted() {
    if (!this.theUser.webPushEnabled && !this.theUser.smsEnabled) {
      this.$router.replace('/campaigns/')
    }

    this.api.getMessagingData()
    .then((response) => {
      const languages = response.languages
      languages.unshift({
        value: 'any',
        label: this.$t('NotificationsApp.Any Language')
      })
      this.store.languages = languages
      this.store.domains = response.domains
      this.store.countries = response.countries
      this.store.accountTimezone = response.accountTimezone
      this.store.sessionKey = response.sessionKey

      window.INSIGHTS_CONFIG = window.INSIGHTS_CONFIG || {}
      window.INSIGHTS_CONFIG.authKey = this.store.sessionKey

      this.loading = false
    })
  },
  provide() {
    return {
      store: this.store
    }
  }
}
</script>